import { IActivityBase, IActivityScheduleBase } from '../../models/activities';
import {
  IBookingBase,
  IBookingCancellationHistoryBase,
  IBookingCheckinBase,
  IBookingItemBase,
  IBookingPaymentBase,
  IBookingPaymentItemBase,
  IBookingScheduleItemBase,
} from '../../models/bookings';
import { IFeatureGroupBase } from '../../models/features';
import { ISpotBase } from '../../models/spots';
import { IUserAssignmentBase, IUserBase } from '../../models/users';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';

export interface IDetailedBookingActivity extends IActivityBase {
  spot: ISpotBase;
}

export interface IDetailedBookingActivitySchedule
  extends IActivityScheduleBase {
  activity: IDetailedBookingActivity;
}

interface IUserAssignment extends IUserAssignmentBase {
  featureGroup: IFeatureGroupBase;
  host?: IUserBase;
}

export interface IDetailedBookingUser extends IUserBase {
  userAssignments: IUserAssignment[];
}

export interface IDetailedBookingActivityScheduleItem
  extends IBookingScheduleItemBase {
  user?: IUserBase;
}

interface IDetailedBookingPayment extends IBookingPaymentBase {
  items: IBookingPaymentItemBase[];
}

interface IDetailedBookingCancellationHistory
  extends IBookingCancellationHistoryBase {
  user: IUserBase;
}

export interface IDetailedBooking extends IBookingBase {
  activitySchedule: IDetailedBookingActivitySchedule;
  checkins: IBookingCheckinBase[];
  user: IDetailedBookingUser;
  bookingItems: IBookingItemBase[];
  payment?: IDetailedBookingPayment;
  bookingScheduleItems: IDetailedBookingActivityScheduleItem[];
  cancellationHistory?: IDetailedBookingCancellationHistory;
}

export const showBookingsService = async (
  bookingId: string,
): Promise<IDetailedBooking> => {
  const { data } = await jhsfBookingsApi.get<IDetailedBooking>(
    `/v2/bookings/${bookingId}`,
  );

  return data;
};
